import { useState, useEffect } from 'react';
import { useCart } from '../context/CartContext';
import logo from '../assets/logo.jpeg';

export default function Navbar({ onCartClick, onAuthClick, onNavigate, currentPage }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { cartCount } = useCart();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    { label: 'Home', page: 'home' },
    { label: 'Products', page: 'products' },
    { label: 'Our Story', page: 'story' },
    { label: 'Contact', page: 'contact' },
  ];

  return (
    <>
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
        padding: scrolled ? '8px 0' : '14px 0',
        background: scrolled ? 'rgba(250,248,242,0.95)' : 'rgba(250,248,242,0.6)',
        backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
        borderBottom: scrolled ? '1px solid rgba(74,124,89,0.1)' : '1px solid transparent',
        transition: 'all 0.4s cubic-bezier(0.4,0,0.2,1)',
      }}>
        <div className="container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {/* Logo */}
          <div onClick={() => onNavigate('home')} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10 }}>
            <img src={logo} alt="Gramaayam" style={{
              height: scrolled ? 42 : 50, transition: 'height 0.3s',
              borderRadius: '50%', objectFit: 'cover',
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            }} />
            <div className="hide-mobile">
              <div style={{
                fontFamily: "'Playfair Display', serif", fontSize: 20, fontWeight: 700,
                color: '#2D5A3F', letterSpacing: 1.5, lineHeight: 1.1,
              }}>Gramaayam</div>
              <div style={{
                fontFamily: "'Cormorant Garamond', serif", fontSize: 10,
                color: '#7A8B6F', letterSpacing: 3, textTransform: 'uppercase',
              }}>where purity begins</div>
            </div>
          </div>

          {/* Desktop Nav */}
          <div className="hide-mobile" style={{ display: 'flex', alignItems: 'center', gap: 32 }}>
            {navLinks.map(({ label, page }) => (
              <button key={page} onClick={() => onNavigate(page)} style={{
                background: 'none', border: 'none', fontSize: 14, fontWeight: 500,
                color: currentPage === page ? '#2D5A3F' : '#4A5A4A',
                letterSpacing: 0.3, position: 'relative', padding: '4px 0',
                transition: 'color 0.3s',
              }}>
                {label}
                {currentPage === page && <span style={{
                  position: 'absolute', bottom: -2, left: '50%', transform: 'translateX(-50%)',
                  width: 20, height: 2, background: '#4A7C59', borderRadius: 1,
                }} />}
              </button>
            ))}
          </div>

          {/* Actions */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button onClick={onAuthClick} style={{
              background: 'none', border: 'none', fontSize: 14, fontWeight: 500,
              color: '#4A5A4A', padding: '6px 12px',
            }} className="hide-mobile">Account</button>

            <button onClick={onCartClick} style={{
              background: 'var(--forest)', color: 'var(--cream-warm)',
              border: 'none', padding: '8px 18px', borderRadius: 24,
              fontSize: 13, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6,
              transition: 'all 0.3s', position: 'relative',
            }}>
              🛒 Cart
              {cartCount > 0 && (
                <span style={{
                  background: '#E85D3A', color: '#fff', fontSize: 10, fontWeight: 700,
                  width: 18, height: 18, borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  position: 'absolute', top: -4, right: -4,
                }}>{cartCount}</span>
              )}
            </button>

            {/* Mobile Hamburger */}
            <button className="hide-desktop" onClick={() => setMobileOpen(!mobileOpen)} style={{
              background: 'none', border: 'none', fontSize: 24, padding: '4px 8px', color: '#2D3B2D',
            }}>
              {mobileOpen ? '✕' : '☰'}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div style={{
          position: 'fixed', top: 70, left: 0, right: 0, bottom: 0, zIndex: 999,
          background: 'rgba(250,248,242,0.98)', backdropFilter: 'blur(20px)',
          padding: '32px 24px', animation: 'slideDown 0.3s ease-out',
        }}>
          {navLinks.map(({ label, page }) => (
            <button key={page} onClick={() => { onNavigate(page); setMobileOpen(false); }} style={{
              display: 'block', width: '100%', textAlign: 'left',
              background: 'none', border: 'none', padding: '16px 0',
              fontSize: 20, fontWeight: 600, color: currentPage === page ? '#2D5A3F' : '#4A5A4A',
              borderBottom: '1px solid rgba(74,124,89,0.08)',
              fontFamily: "'Playfair Display', serif",
            }}>
              {label}
            </button>
          ))}
          <button onClick={() => { onAuthClick(); setMobileOpen(false); }} style={{
            display: 'block', width: '100%', textAlign: 'left',
            background: 'none', border: 'none', padding: '16px 0',
            fontSize: 20, fontWeight: 600, color: '#4A5A4A',
            fontFamily: "'Playfair Display', serif",
          }}>
            Account
          </button>
        </div>
      )}
    </>
  );
}
